import { createAction } from 'Utility/Redux';
import { IRewardData } from '../../Utility/RewardHelper';

enum Types {
    CLAIM_REWARDS = 'claimRewards',
}

export const MyPetMiniGameActions = {
    claimRewards: createAction(
        Types.CLAIM_REWARDS,
        resolve => (rewards: IRewardData[]) => resolve(rewards)
    ),
};
